
export default {
	props: {
		crosswordId: {
			type: String,
			required: true,
		},
	},
};
